<template>
  <div
    v-loading="loading"
    class="page-pg-action"
  >
    <el-form
      ref="xmInfo"
      class="c-form"
      :model="xmInfo"
      :inline="true"
      label-position="right"
      label-width="150px"
      label-suffix="："
    >
      <el-row
        class="c-form__row"
      >
        <el-col
          class="c-form__col c-form__part-title"
          :span="24"
        >
          评估结论
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="评估情况说明"
            prop="pgqksm"
          >
            <template
              v-if="type!=='view'"
            >
              <el-input
                v-show="editPgqksm"
                v-model="pgqksm"
                type="textarea"
                :rows="3"
                class="c-form__input"
                placeholder="请输入评估情况说明"
              />
              <textarea-read
                v-show="!editPgqksm"
                v-model="xmInfo.pgqksm"
                class="c-form__read u-line-20"
              />
              <k-button
                v-show="!editPgqksm"
                btn-text="编辑"
                :auth-type="true"
                type="text"
                icon="kestrel-icon ki-edit"
                @click="()=>{editPgqksm=true;pgqksm=xmInfo.pgqksm}"
              />
              <k-button
                v-show="editPgqksm"
                btn-text="保存"
                :auth-type="true"
                type="text"
                icon="kestrel-icon ki-save"
                @click="handleSave()"
              />
              <k-button
                v-show="editPgqksm"
                btn-text="取消"
                :auth-type="true"
                type="text"
                icon="kestrel-icon ki-close"
                @click="editPgqksm=false"
              />
            </template>
            <template v-else>
              <textarea-read
                v-model="xmInfo.pgqksm"
                class="c-form__read u-line-20"
              />
            </template>
          </el-form-item>
        </el-col>
        <el-col
          :span="24"
          class="c-form__col"
        >
          <el-form-item
            class="c-form__item"
            label="高危问题"
            prop="qdxxList"
          >
            <!-- <span>评估单位存在以下高危情形，可直接判定为不合格：</span> -->
            <ul class="u-text-danger dev-o-li">
              <li
                v-for="(item,index) in xmgwwtList"
                :key="item.gwwtDm"
              >
                {{ index+1+'、' }}{{ item.gwwtMc }}
              </li>
            </ul>
            <k-button
              v-if="type!=='view'"
              btn-text="编辑"
              :auth-type="true"
              type="text"
              icon="kestrel-icon ki-edit"
              @click="handleDialog('editGwwt',{id: xmId,type:'edit'})"
            />
          </el-form-item>
        </el-col>
        <el-col
          :span="24"
          class="c-form__col"
        >
          <el-form-item
            class="c-form__item"
            label="签到信息"
            prop="qdxxList"
          >
            <template v-if="xmInfo.qdxxList && xmInfo.qdxxList.length > 0">
              <span
                class="c-form__read"
              >{{ xmInfo.qdxxList[0].qdsj | date("yyyy-MM-dd HH:mm:ss") }}
                {{ xmInfo.qdxxList[0].qdr }} {{ xmInfo.qdxxList[0].qddz }}
              </span>
              <el-popover
                v-if="xmInfo.qdxxList.length > 1"
                placement="right"
                trigger="click"
              >
                <div
                  v-for="(item, index) in xmInfo.qdxxList"
                  :key="index"
                >
                  <span
                    class="c-form__read"
                  >{{ item.qdsj | date("yyyy-MM-dd HH:mm:ss") }}
                    {{ item.qdr }} {{ item.qddz }}
                  </span>
                </div>
                <el-link
                  slot="reference"
                  type="primary"
                  :underline="false"
                >
                  详情
                </el-link>
              </el-popover>
            </template>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="消防安全等级"
            prop="xfaqdj"
          >
            <span>
              {{ xmInfo.xfaqdj }}
            </span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="综合评定评分"
            prop="zhpddf"
          >
            <span>
              {{ xmInfo.zhpddf }}
            </span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="评估提醒"
            prop="pgtx"
          >
            <el-link
              :underline="false"
              type="primary"
            >
              未完成（{{ xmInfo.wwc }}）
            </el-link>
            <el-link
              :underline="false"
              type="primary"
            >
              已完成（{{ xmInfo.ywc }}）
            </el-link>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="评估报告"
            prop="bgbh"
          >
            <span
              v-if="fd.bgbh"
              type="primary"
              class="u-mg-r-6 c-form__read u-text-primary"
            >
              {{ xmInfo.bgbh }}
            </span>
            <k-button
              v-if="xmInfo.bgbh"
              btn-text="查看评估报告"
              :auth-type="false"
              type="primary"
              plain
              icon="kestrel-icon ki-file-pdf"
              :disabled="xmInfo.previewPdf"
              @click="(e)=>$utils.previewPdf(e,xmInfo.bgUrl,xmInfo)"
            >
              <i
                v-show="xmInfo.previewPdf"
                class="el-icon-loading"
              />
            </k-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template>
      <div
        class="o-part-title"
      >
        <span
          class="u-mg-r-10"
        >
          评估成员
        </span>
        <k-button
          v-if="type!=='view'"
          btn-text="编辑"
          :auth-type="true"
          type="primary"
          plain
          icon="kestrel-icon ki-edit"
          @click="handleDialog('addPgcy',{id: xmId})"
        />
      </div>

      <k-table
        ref="pgcyKTable"
        :table-column="pgcyTableColumn"
        :data="pgcyList"
        :pagination-show="false"
      >
        <template
          #pgfg="scope"
        >
          <el-input
            v-show="scope.row.cyId === fd.id"
            v-model="fd.pgfg"
          />
          <span
            v-show="scope.row.cyId !== fd.id"
          >{{ scope.row.pgfg }}</span>
        </template>
        <el-table-column
          v-if="type!=='view'"
          prop="enabled"
          label="操作"
          width="120"
          align="center"
          fixed="right"
        >
          <template
            slot-scope="scope"
          >
            <div>
              <k-button
                v-show="scope.row.cyId !== fd.id"
                btn-text="编辑"
                :auth-type="true"
                plain
                type="text"
                @click="handleEditPgcy(scope.row)"
              />
              <k-button
                v-show="scope.row.cyId !== fd.id"
                btn-text="删除"
                :auth-type="true"
                type="text"
                @click="handleDelPgcy(scope.row, scope.$index)"
              />
            </div>
            <k-button
              v-show="scope.row.cyId === fd.id"
              btn-text="保存"
              :auth-type="true"
              type="text"
              @click="handleUpdatePgcy()"
            />
            <k-button
              v-show="scope.row.cyId === fd.id"
              btn-text="关闭"
              :auth-type="false"
              type="text"
              @click="resetForm()"
            />
          </template>
        </el-table-column>
      </k-table>
    </template>
    <template>
      <div
        class="o-part-title"
      >
        <span
          class="u-mg-r-10"
        >
          建筑信息
        </span>
        <k-button
          v-if="type!=='view'"
          btn-text="新增"
          :auth-type="true"
          type="primary"
          plain
          icon="kestrel-icon ki-plus"
          @click="handleDialog('addJz',{xmid: xmId, type:'add'})"
        />
      </div>

      <k-table
        ref="kTable"
        :table-column="jzxxTableColumn"
        :data="jzxxList"
        :pagination-show="false"
      >
        <template
          #jzwmc="scope"
        >
          <el-link
            type="primary"
            @click="handleDialog('viewJz', {id: scope.row.id, xmid: xmId})"
          >
            {{ scope.row.jzwmc }}
          </el-link>
        </template>
        <el-table-column
          v-if="type!=='view'"
          prop="enabled"
          label="操作"
          width="120"
          align="center"
          fixed="right"
        >
          <template
            slot-scope="scope"
          >
            <k-button
              btn-text="编辑"
              :auth-type="true"
              type="text"
              plain
              @click="handleDialog('editJz',{ xmid: xmId,id: scope.row.id,type:'edit' })"
            />
            <k-button
              btn-text="删除"
              :auth-type="true"
              type="text"
              @click="handleDelJz(scope.row, scope.$index)"
            />
          </template>
        </el-table-column>
      </k-table>
    </template>
    <template>
      <div
        class="o-part-title"
      >
        <span
          class="u-mg-r-10"
        >
          评估仪器
        </span>
        <k-button
          v-if="type!=='view'"
          btn-text="编辑"
          :auth-type="true"
          type="primary"
          plain
          icon="kestrel-icon ki-edit"
          @click="handleDialog('addPgyq',{id: xmId})"
        />
      </div>
      <k-table
        ref="pgyqTable"
        :table-column="pgyqTableColumn"
        :data="xmPgyqList"
        :pagination-show="false"
      >
        <!-- <el-table-column
          prop="enabled"
          label="操作"
          width="80"
          align="center"
          fixed="right"
        >
          <template
            slot-scope="scope"
          >
            <k-button
          btn-text="导出"
:auth-type="false"
              type="text"
              @click="handleDelPgyq(scope.row, scope.$index)"
            >
              删除
            </k-button>
          </template>
        </el-table-column> -->
      </k-table>
    </template>

    <!--高危问题-->
    <gwwt-dialog
      v-if="showDialogName === 'editGwwt'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="handleUpdateGwwt"
    />

    <!-- 添加/修改 建筑信息 -->
    <update-jzxx-dialog
      v-if="showDialogName === 'editJz' || showDialogName === 'addJz'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="queryJzxx()"
    />

    <!-- 添加/修改 建筑信息 -->
    <view-jzxx-dialog
      v-if="showDialogName === 'viewJz'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
    />

    <!--添加评估成员-->
    <add-pgcy-dialog
      v-if="showDialogName==='addPgcy'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="queryPgcy()"
    />

    <!-- 添加评估仪器 -->
    <add-pgyq-dialog
      v-if="showDialogName === 'addPgyq'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="queryPgyq"
    />
  </div>
</template>

<script>
import { pgxmDetailsService } from './pgxmDetails.service.js';
import { pgxmManageService } from '../pgxm.service.js';
import { jzxxService } from '../jzxx/jzxx.service.js';
import { pgcyService } from '../pgcy/pgcy.service.js';
export default {
  name: 'ActionInfo',
  components: {
    updateJzxxDialog: () => import('../jzxx/updateJzxxDialog'),
    viewJzxxDialog: () => import('../jzxx/viewDialog'),
    addPgcyDialog: () => import('../pgcy/addPgcyDialog'),
    addPgyqDialog: () => import('./pgyqDialog'),
    gwwtDialog: () => import('../componentsDialog/gwwtDialog')
  },
  props: {
    xmInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    type: {
      type: String,
      default: 'view'
    }
  },
  data () {
    return {
      loading: false,
      xmId: null,
      pgyqTableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'sbmc', label: '设备名称', align: 'left', minWidth: '120', type: 'text' },
        { key: 'sbbh', label: '设备编号', align: 'left', minWidth: '120', type: 'text' },
        { key: 'jyzjbh', label: '检定/校准证书编号', align: 'left', minWidth: '80', type: 'text' },
        { key: 'yxq', label: '有效期', align: 'left', minWidth: '80', type: 'date' }
      ],
      pgyqList: [],
      xmPgyqList: [],
      gwwtList: [],
      xmgwwtList: [],
      pgcyList: [],
      pgcyTableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'name', label: '姓名', align: 'left', width: '120', type: 'text' },
        { key: 'zw', label: '职务/职称', align: 'left', minWidth: '80', type: 'text' },
        { key: 'zyzgzsbh', label: '执业资格证书编号', align: 'left', minWidth: '80', type: 'text' },
        { key: 'pgfg', slotName: 'pgfg', label: '评估分工', align: 'left', minWidth: '280', type: 'text' }
      ],
      jzxxList: [],
      jzxxTableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'jzwmc', slotName: 'jzwmc', label: '建筑名称', align: 'left', minWidth: '120', type: 'text' },
        { key: 'zdmj', label: '占地面积（m²）', align: 'left', minWidth: '120', type: 'text' },
        { key: 'jzmj', label: '建筑面积（m²）', align: 'left', minWidth: '80', type: 'text' },
        { key: 'lcs', label: '楼层数', align: 'center', minWidth: '80', type: 'text' },
        { key: 'jzgd', label: '建筑高度（m）', align: 'center', minWidth: '80', type: 'text' }
      ],

      fd: {
        id: null,
        pgfg: null
      },

      editPgqksm: false,
      pgqksm: null,

      /* 弹窗 start */
      showDialogName: '',
      dialogParams: {}
      /* 弹窗 end */
    };
  },
  methods: {
    init () {
      const _this = this;

      pgxmDetailsService.pgxmActionInfo(_this.xmId, {
        pageSize: 600,
        pageNo: 1
      })
        .then(rsp => {
          _this.pgcyList = rsp[0].data;
          _this.jzxxList = rsp[1].data.rows;
        })
        .catch(err => {
          console.error('获取信息错误', err);
        });

      pgxmDetailsService.pgPreloadInfo(_this.xmId, {
        sfqy: 'Y',
        xmId: _this.xmId,
        pageSize: 600,
        pageNo: 1
      })
        .then(rsp => {
          // 评估仪器列表
          _this.pgyqList = rsp[0].data.rows;

          if (rsp[1].data.length > 0) {
            // 该项目的已存在的评估仪器
            rsp[1].data.forEach(item => {
              const equalList = _this.pgyqList.filter(_item => _item.id === item.id);
              if (equalList.length > 0) {
                // 查看详情页面显示该项目下的评估仪器数据
                _this.xmPgyqList.push(equalList[0]);
              }
            });
          }
          _this.gwwtList = rsp[2].data;

          if (rsp[3].data.length > 0) {
            // 该项目的已存在的高危问题
            rsp[3].data.forEach(item => {
              const equalList = _this.gwwtList.filter(_item => _item.gwwtDm === item.gwwtDm);
              // 查看详情页面显示该项目下的高危问题数据
              _this.xmgwwtList.push(equalList[0]);
            });
          }
        })
        .catch(err => {
          console.error('获取信息错误', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    queryJzxx () {
      const _this = this;
      pgxmDetailsService.jzxxQuery(_this.xmId, {
        pageSize: 600,
        pageNo: 1
      })
        .then(rsp => {
          _this.jzxxList = rsp.data.rows;
        })
        .catch(err => {
          console.error('获取建筑信息错误', err);
        });
    },
    queryPgcy () {
      const _this = this;
      pgxmDetailsService.pgcyQuery(_this.xmId)
        .then(rsp => {
          _this.pgcyList = rsp.data;
        })
        .catch(err => {
          console.error('获取评估成员信息错误', err);
        });
    },
    queryPgyq (_pgyqList) {
      this.xmPgyqList = _pgyqList;
    },
    /**
     * @description: 删除
     * @return {*}
     */
    handleDelPgcy (_row) {
      const _this = this;
      _this.$confirm('是否确认删除此评估成员？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        pgcyService.delPgcy(_this.xmId, _row.cyId)
          .then(rsp => {
            this.$message({
              message: '删除成功！',
              type: 'success'
            });
            _this.queryPgcy();
          })
          .catch(err => {
            console.error('删除失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {

      });
    },
    /**
     * @description: 删除
     * @return {*}
     */
    handleDelJz (_row) {
      const _this = this;
      _this.$confirm('是否确认删除此条建筑信息记录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        jzxxService.delJzxx(this.xmId, _row.id)
          .then(rsp => {
            this.$message({
              message: '删除成功！',
              type: 'success'
            });
            _this.queryJzxx();
          })
          .catch(err => {
            console.error('删除失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },
    handleUpdatePgcy () {
      if (this.fd.pgfg && this.fd.pgfg.length > 300) {
        this.$message({
          message: '【评估分工】长度不能超出300位',
          type: 'warning'
        });
        return;
      }
      this.loading = true;
      pgcyService.updatePgcy(this.xmId, this.fd)
        .then(rsp => {
          this.$message({
            message: '修改成功！',
            type: 'success'
          });
          this.queryPgcy();
          this.resetForm();
        })
        .catch(err => {
          console.error('修改评估评估分工错误！', err);
        }).finally(() => {
          this.loading = false;
        });
    },
    resetForm () {
      this.fd.id = null;
      this.pgfg = null;
    },
    handleEditPgcy (obj) {
      this.fd.id = obj.cyId;
      this.fd.pgfg = obj.pgfg;
    },
    /**
     * @description: 修改保存
     * @return {*}
     */
    handleSave () {
      this.loading = true;
      const qksm = this.pgqksm;
      pgxmManageService.update(this.xmId, { ...this.xmInfo, pgqksm: qksm })
        .then(rsp => {
          this.$message({
            message: '修改成功！',
            type: 'success'
          });
          this.xmInfo.pgqksm = qksm;
          this.editPgqksm = false;
        })
        .catch(err => {
          console.error('修改评估情况说明失败！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleUpdateGwwt (_gwwtList) {
      this.xmgwwtList = _gwwtList;
    },
    /**
     * @description: 跳转窗口
     * @author: cgh
     */
    handleDialog (_name, params) {
      this.showDialogName = _name;
      this.dialogParams = params;
    }
  },
  created () {
    this.xmId = this.$route.params.id;
    this.init();
  }
};
</script>
